import React from 'react';
import { firstError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import SaveButton from '@/components/buttons/SaveButton';
import { transformForm } from '@/forms/state/state';
import TabActions from '@/components/tabs/TabActions';
import { catalogueDiff, validateCatalogueSection } from '../helper';
import { datasetStepName } from '../../state/state';
import DatasetWizardCancelButton from '../../containers/DatasetWizardCancelButton';
import Selectors from '../../hooks/selectors';
import Events from '../../hooks/events';

export const validateSecondSectionStep = ({ dataset, template }) => (
  validateCatalogueSection(catalogueDiff(dataset.catalogue, dataset.copy.catalogue), template, 'second')
);

export const validateThirdSectionStep = ({ dataset, template }) => (
  validateCatalogueSection(catalogueDiff(dataset.catalogue, dataset.copy.catalogue), template, 'third')
);

const CatalogueSectionActions = ({
  category,
  code,
  compact,
  goBack,
  goForward,
}) => {
  const state = Selectors.useDatasetWizardActionsContainer({ category, code });
  const step = datasetStepName(state.activeStepIndex);
  const updateCatalogue = Events.useUpdateDatasetCatalogue(category, { code });
  const updateErrors = Events.useUpdataDatasetValidationErrors(category, { code });
  const create = Events.useCreateDataset(category, { code });
  const update = Events.useUpdateDataset(category, { code });

  const proceedToSave = (catalogueToSave) => {
    const errors = validateCatalogueSection(catalogueToSave, state.template, step);
    updateErrors({ errors });

    return errors.length === 0;
  };

  const submitForm = () => {
    const catalogue = catalogueDiff(state.dataset.catalogue, state.dataset.copy.catalogue);

    if (!catalogue) {
      goForward();
    } else if (proceedToSave(catalogue)) {
      if (state.isDirty.dictionaries) {
        updateCatalogue({ catalogue, template: state.template });
      } else { update({ properties: { catalogue }, template: state.template }); }
    }
  };

  const onSaveClick = () => {
    if (!state.dataset.isNew) {
      submitForm();
    } else if (proceedToSave(transformForm(state.dataset.catalogue))) {
      create(state);
    }
  };

  return (
    <TabActions className="aridhia-dataset-wizard-actions">
      <DatasetWizardCancelButton category={category} code={code} />
      <BackButton onClick={goBack} iconOnly={compact} disabled={state.saveStatus === states.PENDING} />
      {(!state.isDirty.catalogue || step !== state.sectionsWithFields[state.sectionsWithFields.length - 1]) && (
        <ForwardButton
          disabled={firstError(state.readErrors)}
          iconOnly={compact}
          onClick={goForward}
        />
      )}
      {state.isDirty.catalogue && step === state.sectionsWithFields[state.sectionsWithFields.length - 1] && (
      <SaveButton
        iconName="chevron right"
        iconOnly={compact}
        inProgress={state.saveStatus === states.PENDING}
        messageId="actions.save.next"
        minimumDataEntryMet
        onClick={onSaveClick}
      />
      )}
    </TabActions>
  );
};

export default CatalogueSectionActions;
